import { useState } from 'react';
import TemaCard from 'src/components/cards/TemaCardList';
import { allTemas } from 'src/data/temas/AllTemas';
import TopicSelector from '../components/topic/TopicSelector';
import { topics } from 'src/utils/constants';
import PageStructure from 'src/components/wrappers/PageStructure';


const Topics = () => {
  const [selectedTheme, setSelectedTheme] = useState<string>('Everyday Encounters');

  // Filter the cards based on the selected theme
  const filteredCards = allTemas.filter((card) => card.topic === selectedTheme);

  return (
    <PageStructure
      TitleNode={
        <div>
          <span className="label">Topic: </span>
          <span className="theme">{selectedTheme}</span>
        </div>
      }
      Page={
        <div>
          <TopicSelector
            topics={topics}
            selectedTheme={selectedTheme}
            onThemeChange={setSelectedTheme}
          />
          <TemaCard cards={filteredCards} />
        </div>
      }
    />
  );
};

export default Topics;
